
import React from 'react';
import { Alert, AlertDescription } from "@/components/ui/alert";
import RegistrationGuard from "@/components/auth/RegistrationGuard";

const ErrorState: React.FC = () => {
  return (
    <RegistrationGuard>
      <div className="space-y-8 animate-fade-in">
        <div>
          <h1 className="text-3xl font-bold">Escolha seu Psicólogo</h1>
          <p className="text-muted-foreground">Erro ao carregar psicólogos</p>
        </div>
        <Alert variant="destructive">
          <AlertDescription>
            Erro ao carregar a lista de psicólogos. Tente recarregar a página.
          </AlertDescription>
        </Alert>
      </div>
    </RegistrationGuard>
  );
};

export default ErrorState;
